module.exports = __webpack_public_path__ + "media/images/trophy-ea7cb421a0b92bcf572fc207bbd24d29.svg";